// document.querySelectorAll('.featured-swiper').forEach((swiperEl, index) => {
//   // Unique selectors for navigation buttons inside this swiper section
//   const nextEl = swiperEl.parentElement.querySelector('.next-btn-swip');
//   const prevEl = swiperEl.parentElement.querySelector('.prev-btn-swip');

//   const swiperInstance = new Swiper(swiperEl, {
//     slidesPerView: 'auto',
//     navigation: {
//       nextEl: nextEl,
//       prevEl: prevEl
//     }
//   });

// });

 document.addEventListener("DOMContentLoaded", function() {
  const swiper = new Swiper('.featured-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: false,
    navigation: {
      nextEl: '.feature-collection-section .arrow-right',
      prevEl: '.feature-collection-section .arrow-left',
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      },
      1250: {
        slidesPerView: 4
      },
    },
  });
});
